import React from 'react';

export function LoadingIcon() {

    return (
        <div className="loader_section">
            <img
                src={process.env.REACT_APP_URL + "img/loading-icon.gif"}
                alt="logo"
            />
        </div>
    );


}
